export const reportingInstreamAdQuartileNames = {
  firstQuartile: 'QUARTILE_FIRST',
  midPoint: 'QUARTILE_MIDPOINT',
  thirdQuartile: 'QUARTILE_THIRD',
};
